export default "__VITE_ASSET__q6eGtnr9__"